import {
  Constructor,
  GraphComponent,
  ILabel,
  IRenderContext,
  LabelStyleBase,
  Size,
} from '@ardoq/yfiles';
import { LabelExportSupport } from '@ardoq/graph';
import { MODERNIZED_BLOCK_DIAGRAM_URL_ICON_SIZE as ICON_SIZE } from './modernized/consts';
import { UrlLabelVisual } from './UrlLabelVisual';

/**
 * Export support for URL labels - excludes them from JSON export
 * since they are purely visual indicators and not semantic labels
 */
const urlLabelExportSupport = {
  toJSON: (_gc: GraphComponent, _label: ILabel) => [],
} satisfies LabelExportSupport;

class UrlLabelStyle extends LabelStyleBase {
  static Instance = new UrlLabelStyle();
  private constructor() {
    super();
  }

  protected override lookup(label: ILabel, type: Constructor): unknown {
    if (type === LabelExportSupport) {
      return urlLabelExportSupport;
    }
    return super.lookup(label, type);
  }

  override createVisual(context: IRenderContext, label: ILabel) {
    return new UrlLabelVisual(label);
  }

  override getPreferredSize() {
    const urlIconSize = ICON_SIZE;
    return new Size(urlIconSize, urlIconSize);
  }
}
export { UrlLabelStyle };
